import { useEffect } from "react";
import { Navbar } from "@/components/landing/Navbar";
import { Footer } from "@/components/landing/Footer";
import { ProductsHero } from "@/components/products/ProductsHero";
import { ProductsIntro } from "@/components/products/ProductsIntro";
import { ProductFamily } from "@/components/products/ProductFamily";
import { PlatformConfig } from "@/components/products/PlatformConfig";
import { ProductsStorage } from "@/components/products/ProductsStorage";
import { ProductsProcess } from "@/components/products/ProductsProcess";
import { ProductsCTA } from "@/components/products/ProductsCTA";

export default function Products() {
  useEffect(() => {
    window.lenis?.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, []);

  return (
    <div data-testid="products-page" className="bg-baseLight min-h-screen">
      <Navbar />
      <ProductsHero />
      <ProductsIntro />
      <ProductFamily />
      <PlatformConfig />
      <ProductsStorage />
      <ProductsProcess />
      <ProductsCTA />
      <Footer />
    </div>
  );
}
